// lazyWithRetry — React.lazy con auto-recuperación ante ChunkLoadError.
//
// Con code-splitting, cada deploy invalida los chunks anteriores (el deploy hace
// `aws s3 sync --delete`): una sesión abierta con el index.html antiguo que navegue
// a una ruta aún no visitada pediría un chunk que ya no existe y el import() falla.
// También falla si la red se corta a mitad de descarga del chunk.
//
// Recuperación: forzamos UNA recarga completa (trae el index.html + chunks nuevos).
// El flag en sessionStorage evita bucles de recarga si el fallo persiste (sin red);
// se limpia cuando el chunk carga bien para permitir recuperarse de futuros deploys.
import { lazy } from "react";

export function lazyWithRetry(importFn, chunkKey) {
  const storageKey = `chunk_reload:${chunkKey}`;
  return lazy(() =>
    importFn()
      .then((module) => {
        try {
          sessionStorage.removeItem(storageKey);
        } catch (_) {}
        return module;
      })
      .catch((error) => {
        let alreadyReloaded = false;
        try {
          alreadyReloaded = sessionStorage.getItem(storageKey) === "1";
          if (!alreadyReloaded) sessionStorage.setItem(storageKey, "1");
        } catch (_) {}
        if (!alreadyReloaded) {
          window.location.reload();
          // Mientras el navegador recarga, dejamos la promesa pendiente para
          // no renderizar un error transitorio.
          return new Promise(() => {});
        }
        throw error;
      })
  );
}
